import { createContext, ReactNode, useContext, useState } from "react";
import { IGetGroupsLeanFilter } from "../../repositories/models/group/get-group.model";

interface IGroupsLeanFilterProps {
  children: ReactNode;
}

interface IGroupsLeanFilterContext {
  filter: IGetGroupsLeanFilter;
  setFilter: (filters: IGetGroupsLeanFilter) => void;
}

export const GroupsLeanFilterContext = createContext<IGroupsLeanFilterContext>({} as IGroupsLeanFilterContext);

export const useGroupsLeanFilterContext = () => {
  return useContext(GroupsLeanFilterContext);
};

const useGroupsLeanFilterProvider = (_props: IGroupsLeanFilterProps): IGroupsLeanFilterContext => {
  const [filters, setFilters] = useState<IGetGroupsLeanFilter>({
    groupType: undefined,
    nameQuery: undefined,
    erpQuery: undefined,
  });

  return {
    filter: filters,
    setFilter: setFilters,
  };
};

export const GroupsLeanFilterProvider = (props: IGroupsLeanFilterProps) => {
  const value = useGroupsLeanFilterProvider(props);
  return <GroupsLeanFilterContext.Provider value={value}>{props.children}</GroupsLeanFilterContext.Provider>;
};
